var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{class:{ 'line-clamp-3 line-clamp-1-mobile': !_vm.expand }},[_vm._t("default")],2),_vm._v(" "),_c('a',{staticClass:"cursor-pointer text-bold text-underline",on:{"click":function($event){_vm.expand = !_vm.expand}}},[_c('span',[_vm._v("\n            "+_vm._s(_vm.expand ? 'Menos' : 'Mais')+"\n        ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }